import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { setFormFieldValue, validateFormField } from '../../../reducers/formReducer'

export class BirthDateField extends Component {
  constructor(props) {
    super(props)
    const { year, month, day } = this.props
    this.state = {
      birthYear: year || '',
      birthMonth: month || '',
      birthDay: day || '',
    }
    this.valueChange = this.valueChange.bind(this)
    this.validateBirthDateField = this.validateBirthDateField.bind(this)
    this.validateBirthDate = this.validateBirthDate.bind(this)
  }

  componentWillMount() {
    this.validateBirthDate()
  }

  valueChange(e, maxLength) {
    e.preventDefault()
    let value = e.target.value
    const name = e.target.name
    if (maxLength) {
      value = value.slice(0, maxLength)
    }
    this.setState({ [name]: value }, () => {
      this.validateBirthDate()
    })
  }

  validateBirthDateField(inputName, minValue, maxValue) {
    const val = this.state[inputName]
    return val !== '' && val <= maxValue && val >= minValue
  }

  validateBirthDate() {
    const { formType, fieldName } = this.props
    const birthYear = this.validateBirthDateField('birthYear', 1900, new Date().getFullYear())
    const birthMonth = this.validateBirthDateField('birthMonth', 1, 12)
    const birthDay = this.validateBirthDateField('birthDay', 1, 31)
    if (birthYear && birthMonth && birthDay) {
      const date = new Date(this.state.birthYear, this.state.birthMonth - 1, this.state.birthDay)
      if (this.state.birthMonth - 1 !== date.getMonth()) {
        this.props.setFormFieldValue(formType, fieldName, '')
        this.props.validateFormField(formType, fieldName, false)
      } else {
        this.props.setFormFieldValue(formType, fieldName, date.getTime())
        this.props.validateFormField(formType, fieldName, true)
      }
    } else {
      this.props.setFormFieldValue(formType, fieldName, '')
      this.props.validateFormField(formType, fieldName, false)
    }
  }

  render() {
    const { fieldName, label, additionalClass } = this.props
    return (
      <div className={`field field-birthdate ${additionalClass || ''}`}>
        {label && (
          <label htmlFor={fieldName} className="label">
            {label}
          </label>
        )}
        <div className="columns">
          <div>
            <input
              type="number"
              maxLength={4}
              min={1900}
              max={new Date().getFullYear()}
              name="birthYear"
              className={`input ${
                this.validateBirthDateField('birthYear', 1900, new Date().getFullYear())
                  ? ''
                  : 'is-danger'
              }`}
              value={this.state.birthYear}
              onChange={(e) => this.valueChange(e, 4)}
              placeholder="YYYY"
            />
          </div>
          <div>
            <input
              type="number"
              maxLength={2}
              min={1}
              max={12}
              name="birthMonth"
              className={`input ${
                this.validateBirthDateField('birthMonth', 1, 12) ? '' : 'is-danger'
              }`}
              value={this.state.birthMonth}
              onChange={(e) => this.valueChange(e, 2)}
              placeholder="MM"
            />
          </div>
          <div>
            <input
              type="number"
              maxLength={2}
              min={1}
              max={31}
              name="birthDay"
              className={`input ${
                this.validateBirthDateField('birthDay', 1, 31) ? '' : 'is-danger'
              }`}
              onChange={(e) => this.valueChange(e, 2)}
              value={this.state.birthDay}
              placeholder="DD"
            />
          </div>
        </div>
      </div>
    )
  }
}

BirthDateField.propTypes = {
  form: PropTypes.object,
  formType: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.string,
  year: PropTypes.number,
  month: PropTypes.number,
  day: PropTypes.number,
  additionalClass: PropTypes.string,
  setFormFieldValue: PropTypes.func,
  validateFormField: PropTypes.func,
}

export default connect(
  (state) => {
    return {
      form: state.form,
    }
  },
  { setFormFieldValue, validateFormField },
)(BirthDateField)
